import { SOLICITUD_TIPOS } from 'assets/data/SolicitudesEstados';
import { useAppApi, useUAppApi } from 'hooks/useAppApi';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useCalendarActions } from './CalendarSolc/CalendarActionsProvider';

const SolicitudesContext = createContext(null);

export const SolicitudesProvider = ({ children, id }) => {
  const { selectedDay } = useCalendarActions();
  const map = useCallback((result) => {
    return result;
  }, []);

  const { data, isLoading, error, hasCalled, call } = useAppApi({
    baseUrl: '/solicitudes',
    mapResults: map,
  });

  const mapUpdate = useCallback((result) => {
    return result;
  }, []);

  const { call: update, isLoading: isLoadingUpdate } = useUAppApi({
    url: '/solicitudes',
    mapResults: mapUpdate,
  });

  const saveSolicitud = async (solicitud) => {
    const { SolicitudTipo, Cliente, ...solc } = solicitud;
    await update(solc, `/${solicitud.id}`);
    call();
  };
  const [solicitudes, setSolicitudes] = useState([]);

  useEffect(() => {
    setSolicitudes(data);
  }, [data]);

  const addSolicitudToDay = async (solicitud, day) => {
    const newSolicitud = {
      ...solicitud,
      fecha_asignacion: day.format('YYYY-MM-DD'),
      status: solicitud.encargado ? SOLICITUD_TIPOS.ASIGNADA : SOLICITUD_TIPOS.SIN_ASIGNAR,
      // status: ASIGNADO,
      // status: ASIGNADO,
    };
    await saveSolicitud(newSolicitud);
  };

  const deleteSolicitudToDay = async (solicitud, day, index) => {
    const newSolicitud = {
      ...solicitud,
      fecha_asignacion: null,
      status: SOLICITUD_TIPOS.SIN_ASIGNAR,
      // Desasignar = sin técnico. Enviar el null explícito para que el backend
      // limpie `encargado_user_id`; sin esto el spread `...solicitud` rearrastra
      // el id viejo y la solicitud queda pegada al técnico (bug #4/#6).
      encargado: null,
      encargado_user_id: null,
    };
    await saveSolicitud(newSolicitud);
  };

  const asignSpecialist = async (solicitud, userId) => {
    // Migración rut→id: el Select entrega el id del técnico; el backend deriva
    // encargado_user_id desde `encargado` (decisión 8).
    const newSolicitud = {
      ...solicitud,
      encargado: userId,
      status: SOLICITUD_TIPOS.ASIGNADA,
    };

    await saveSolicitud(newSolicitud);
  };

  const setHoraInicio = async (solicitud, horaInicio) => {
    await saveSolicitud({ ...solicitud, hora_inicio: horaInicio });
  };

  return (
    <SolicitudesContext.Provider
      value={{
        call,
        id,
        isLoading,
        error,
        hasCalled,
        data: solicitudes,
        addSolicitudToDay,
        deleteSolicitudToDay,
        asignSpecialist,
        setHoraInicio,

        selectedData: solicitudes?.filter(
          (solicitud) => solicitud.fecha_asignacion === selectedDay.format('YYYY-MM-DD')
        ),
        // activeData: data?.filter((element) => element.active === true),
      }}
    >
      {children}
    </SolicitudesContext.Provider>
  );
};

export const useSolicitudes = () => useContext(SolicitudesContext);
